export const Module = 'EmailTemplates';
